$(document).ready(function () {

    // Focus Searchfield on Click
    $('.searchform.searchform--minimal').on('touchstart', function (e) {
        $(this).find('input').focus();
    }).on('click', function (e) {
        $(this).find('input').focus();
    }).on('focusout', function (e) {
        $(this).find('.js-display-searchfield').removeClass('hidden');
    }).on('focusin', function (e) {
        $(this).find('.js-display-searchfield').addClass('hidden');
    });

    // un-disabled submit btn only on click on search form
    document.querySelectorAll('.searchform .searchfield').forEach((searchField) => {
        searchField.addEventListener('input', function (e) {
            handleSearchInput(searchField);
        });
    });

    // Focus Searchfield on Click
    $('.searchform.searchform--mobile').on('touchstart', function (e) {
        $(this).find('input').focus();
    }).on('click', function (e) {
        $(this).find('input').focus();
    }).on('focusout', function (e) {
        $(this).find('.js-display-searchfield').removeClass('hidden');
        $(this).find('.js-submit-searchfield-button').removeClass('d-none');
    }).on('focusin', function (e) {
        $(this).find('.js-display-searchfield').addClass('hidden');
        $(this).find('.js-submit-searchfield-button').addClass('d-none');
    });
});

function handleSearchInput(searchField) {
    const hasValue = searchField && searchField.value !== '';

    $('.js-submit-searchfield-button').each(function () {
        hasValue ? $(this).removeAttr('type') : $(this).attr('type', 'button');
    });
}
